import SimpleTable from "@/components/SimpleTable";
import { getGradeRangesByTotalScore } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface GradeTableProps {
  grade: string;
  totalPossibleScore: number;
}

function GradeTable({ grade, totalPossibleScore }: GradeTableProps) {
  const { t } = useTranslation();

  const grades = ["S", "A", "B", "C", "D"];
  const head = [
    t("excellent"),
    t("great"),
    t("good"),
    t("can_improve"),
    t("concerning"),
  ];
  const ranges = getGradeRangesByTotalScore(totalPossibleScore);

  const temp = grades.findIndex((g) => g === grade);
  const gradeIndex = temp === -1 ? grades.length - 1 : temp;

  const data = grades.map((grade, index) => ({
    grade: (
      <span
        className={twMerge(gradeIndex === index && "font-bold text-cyan-600")}
      >
        {grade}
      </span>
    ),
    range: (
      <span
        className={twMerge(gradeIndex === index && "font-bold text-cyan-600")}
      >
        {ranges[index]}
      </span>
    ),
  }));

  return (
    <>
      <div className="hidden rounded-lg border sm:block">
        <table className="w-full divide-y">
          <thead>
            <tr>
              {head.map((h, index) => (
                <td
                  key={h}
                  className={twMerge(
                    index === gradeIndex && "bg-cyan-100 text-cyan-600",
                    index !== gradeIndex &&
                      "bg-cool-gray-50 text-cool-gray-900",
                    "px-6 py-3 text-center font-medium",
                  )}
                >
                  {h}
                </td>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y">
            <tr>
              {grades.map((g, index) => (
                <td
                  key={g}
                  className={twMerge(
                    index === gradeIndex && "bg-cyan-100",
                    "px-6 py-4 text-center text-lg font-bold text-cool-gray-900",
                  )}
                >
                  {g}
                </td>
              ))}
            </tr>
            <tr>
              {ranges.map((r, index) => (
                <td
                  key={r}
                  className={twMerge(
                    index === gradeIndex && "bg-cyan-100",
                    "px-6 py-4 text-center text-cool-gray-900",
                  )}
                >
                  {r}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      <SimpleTable
        className="block sm:hidden"
        columns={[
          {
            label: t("grade"),
            key: "grade",
            render: ({ grade }) => grade,
          },
          {
            label: t("range"),
            key: "range",
            render: ({ range }) => range,
          },
        ]}
        data={data}
      />
    </>
  );
}

export default GradeTable;
